import { IAppEntity } from "../../entities";
import { AccountsService } from "../../../services/accounting/accountsService";
import { IAccountDto } from "../../../dtos/accounting/IAccountDto";
import { AccountTypeEnum } from "../../../enums/Accounting/AccountTypeEnum";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupAccount } from "../../../components/Shared/NewForms/NFLookupAccount";
import React from "react";
import ChartOfAccountsList from "../../../components/Pages/Accounting/ChartOfAccountsList";

export const Account: IAppEntity = {
  entityType: "catalog",
  title: "Account",
  pluralTitle: "Accounts",
  apiUrl: "Accounts",
  apiEnum: ReferenceTypes.Account,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return undefined; //React.createElement(BankDetail, {model: model, modelUpdatedEvent: modelUpdatedEvent});
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ChartOfAccountsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupAccount, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new AccountsService(this.apiUrl);
  },
  getEmptyModel(): IAccountDto {
    return {
      accountNo: "",
      name: "",
      accountType: AccountTypeEnum.Active,
      id: "",
      isAmount: false,
      isBalance: false,
      isCurrency: false,
      isQuantity: false,
    };
  },
};
